var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(-936.245 -4767.245)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(936.245 4767.245)",
    fill: "#3b57a9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M890.666,400.517c3.607,3.606,4.425-.565,6.722,1.73,2.213,2.213,3.486,2.656.681,5.461-.351.282-2.583,3.679-10.429-4.159s-4.451-10.08-4.169-10.43c2.812-2.812,3.248-1.537,5.461.681C891.229,396.09,887.06,396.911,890.666,400.517Z",
    transform: "translate(62.155 4384.153)",
    fill: "#3b57a9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImg);
export default __webpack_public_path__ + "static/media/phoneImg.de6f77f24ffc2642d78b0c40ddb7e427.svg";
export { ForwardRef as ReactComponent };